<template>
  <div
    class="slider-element"
    :style="completed"
  >
    <div class="slider-bar completed" />
    <input
      ref="input"
      v-model="localValue"
      class="slider-input slider-bar"
      type="range"
      :min="min"
      :max="max"
      :step="step"
      @change="handleChange"
      @input="handleInput"
    >
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
    min: {
        type: Number,
        default: 0,
    },
    max: {
        type: Number,
        default: 100,
    },
    step: {
        type: Number,
        default: 1,
    },
    modelValue: {
        type: Number,
        default: null,
    },
});

const emit = defineEmits(['update:modelValue', 'change', 'input']);

const input = ref(props.value);

const localValue = computed({
    get: () => props.modelValue,
    set: (value) => {
        emit('update:modelValue', parseFloat(value));
    },
});

const completed = computed(() => ({ '--completed': `${Math.round((localValue.value / props.max) * 100)}%` }));

const handleChange = ($event) => {
    emit('change', parseFloat($event.target.value));
};

const handleInput = ($event) => {
    emit('input', parseFloat($event.target.value));
};
</script>

<style lang="scss">
@import "slider";
</style>
